/*!
 * Oferta "compra 1 y lleva el 2do al 50%" — cantidad siempre editable con +/-,
 * cambio de presentación solo cuando hace falta, y resaltado visual de la
 * presentación elegida.
 * Agregado para Saludable Juntos (no forma parte del tema original).
 *
 * Modelo (a pedido explícito de Patricia):
 * 1) Los botones +/- de cantidad SIEMPRE son presionables, en cualquier
 *    presentación — nunca se bloquean.
 * 2) Si estás en "2 frascos (Oferta 50%)" y con +/- cambias la cantidad a
 *    cualquier valor distinto de 2 (1, 3, 4…), la presentación cambia sola a
 *    "1 frasco" y la cantidad se queda en el número al que la subiste/bajaste
 *    — desde ahí puedes seguir moviéndote libremente a cualquier cantidad.
 * 3) Si estás en "1 frasco" y con +/- llegas exactamente a cantidad 2, NO se
 *    cambia de pestaña (no salta a "2 frascos") — solo se muestra un aviso
 *    debajo indicando que esos 2 frascos ya califican para la oferta; el
 *    precio de oferta se aplica solo al agregar al carrito (ver Parte 2 de
 *    este archivo, que ya convierte automáticamente 2+ unidades de "1 frasco"
 *    a la variante de oferta dentro del carrito). Esto evita el "salto" de
 *    pestaña que antes ocurría al subir la cantidad.
 * 4) Seleccionar una presentación directamente (clic en la pestaña) SÍ fija
 *    la cantidad a su valor natural: "2 frascos" → cantidad 2, "1 frasco" →
 *    cantidad 1.
 * 5) La pestaña de la presentación elegida se resalta en verde (el mismo
 *    verde de marca de la tienda) con texto blanco.
 * 6) En el carrito (página, cajón o notificación): si por cualquier vía el
 *    cliente termina con 2 o más unidades de la variante "1 frasco" de un
 *    mismo producto, las convierte automáticamente a la variante de oferta
 *    y agrega un aviso visual en la línea del carrito. Esto es lo que hace
 *    que el punto 3 de arriba funcione: el precio de oferta se termina
 *    aplicando siempre, aunque en la página de producto no se haya saltado
 *    de pestaña.
 *
 * Por qué es seguro: la cantidad que ve el cliente en la página de producto
 * SIEMPRE coincide con la cantidad real que se envía al carrito (nunca hay
 * una cantidad "decorativa" distinta de la real), así que ningún botón de
 * compra — incluyendo "Comprar con Shop", que lee este campo directamente —
 * puede terminar cobrando de más.
 *
 * Es aditivo: si algo falla (fetch, DOM no encontrado, etc.) no rompe nada,
 * simplemente no aplica la conversión automática — el cliente nunca paga de más.
 */

const SINGLE_RE = /^\s*1\s*frasco/i;
const DOUBLE_RE = /^\s*2\s*frascos?/i;

const MSG_OFFER_WILL_APPLY =
  '🎉 ¡Con 2 frascos obtienes la oferta! El precio especial se aplica automáticamente al agregar al carrito.';
const MSG_OFFER_ACTIVE = '✅ Precio de oferta aplicado (2 frascos).';
const MSG_CART_OFFER_APPLIED = '🎉 Aplicamos tu oferta: 2 frascos al precio especial.';

// Verde de marca de la tienda (settings_data.json → color_brand), el mismo que
// usan los botones principales (ej. "Ver catálogo").
const BRAND_GREEN = '#98b859';

/* ---------------------------------------------------------------------- */
/* Resalte visual de la presentación seleccionada                         */
/* ---------------------------------------------------------------------- */

function injectSelectedPresentationStyles() {
  if (document.getElementById('oferta-2x1-styles')) return;
  const style = document.createElement('style');
  style.id = 'oferta-2x1-styles';
  style.textContent = `
    variant-radios .product-form__swatch__item--button input[type="radio"]:checked + label,
    variant-selects .product-form__swatch__item--button input[type="radio"]:checked + label,
    variant-mixed-inputs .product-form__swatch__item--button input[type="radio"]:checked + label {
      background-color: ${BRAND_GREEN};
      color: #ffffff;
      border-color: ${BRAND_GREEN};
    }
  `;
  document.head.appendChild(style);
}

/* ---------------------------------------------------------------------- */
/* Parte 1: página de producto                                            */
/* ---------------------------------------------------------------------- */

function initProductOfferSync() {
  const variantEl = document.querySelector('variant-radios, variant-selects, variant-mixed-inputs');
  if (!variantEl) return;

  const dataScript = variantEl.querySelector('script[type="application/json"]');
  if (!dataScript) return;

  let variants;
  try {
    variants = JSON.parse(dataScript.textContent);
  } catch (e) {
    return;
  }

  const singleVariant = variants.find((v) => SINGLE_RE.test(v.title || ''));
  const doubleVariant = variants.find((v) => DOUBLE_RE.test(v.title || ''));
  if (!singleVariant || !doubleVariant) return; // no es un producto con este tipo de oferta

  const qtyEl = document.querySelector('quantity-input');
  if (!qtyEl) return;

  const qtyWrapper = qtyEl.closest('.product-form__qty') || qtyEl.parentElement;

  let msgEl = null;
  function ensureMsgEl() {
    if (msgEl) return msgEl;
    msgEl = document.createElement('div');
    msgEl.setAttribute('data-oferta-2x1-msg', '');
    msgEl.style.cssText =
      'margin-top:8px;padding:8px 12px;border-radius:6px;background:#eaf7ec;color:#1e7c34;font-size:13px;font-weight:600;line-height:1.4;display:none;';
    if (qtyWrapper && qtyWrapper.parentElement) {
      qtyWrapper.insertAdjacentElement('afterend', msgEl);
    }
    return msgEl;
  }

  function showMsg(text) {
    const el = ensureMsgEl();
    el.textContent = text;
    el.style.display = 'block';
  }

  function hideMsg() {
    if (msgEl) msgEl.style.display = 'none';
  }

  function setControlValue(optionValue) {
    if (optionValue == null) return true;
    const escaped =
      typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(optionValue) : optionValue.replace(/"/g, '\\"');
    const radio = variantEl.querySelector(`input[type="radio"][value="${escaped}"]`);
    if (radio) {
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    const option = variantEl.querySelector(`select option[value="${escaped}"]`);
    if (option && option.parentElement) {
      const select = option.parentElement;
      if (select.value !== optionValue) {
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    return false;
  }

  function switchToVariant(targetVariant) {
    ['option1', 'option2', 'option3'].forEach((key) => {
      if (targetVariant[key] != null) setControlValue(targetVariant[key]);
    });
  }

  function getCurrentVariant() {
    // No confiamos en el estado interno del tema (puede no estar listo aún al cargar
    // la página); leemos directamente los controles seleccionados en el DOM.
    const controls = Array.from(variantEl.querySelectorAll('input[type="radio"]:checked, select'));
    if (controls.length === 0) return null;
    const values = controls.map((c) => c.value);
    return (
      variants.find((v) =>
        ['option1', 'option2', 'option3'].every((key, i) => {
          if (v[key] == null) return true;
          return i < values.length && v[key] === values[i];
        })
      ) || null
    );
  }

  function setQtyDisplay(n) {
    if (typeof qtyEl.value !== 'undefined') {
      qtyEl.value = n;
    }
  }

  let lastVariantId = null;
  let programmaticSwitch = false;

  function handleQtyUpdate(e) {
    const current = getCurrentVariant();
    if (!current) return;

    const newQty = Number(e.detail && e.detail.value);
    if (!Number.isFinite(newQty) || newQty < 1) return;

    if (current.id === doubleVariant.id) {
      // Estamos en la oferta: cualquier cantidad distinta de 2 nos saca de ella.
      // La cantidad que dejó el propio +/- (1, 3, 4…) NO se toca — ya es correcta.
      if (newQty !== 2) {
        programmaticSwitch = true;
        switchToVariant(singleVariant);
      }
      return;
    }

    // Estamos en "1 frasco": nunca cambiamos de pestaña por cantidad — solo avisamos.
    if (newQty === 2) {
      showMsg(MSG_OFFER_WILL_APPLY);
    } else {
      hideMsg();
    }
  }

  function syncOnVariantChange() {
    const current = getCurrentVariant();
    if (!current) {
      programmaticSwitch = false;
      return;
    }

    const isDouble = current.id === doubleVariant.id;
    const triggeredByQty = programmaticSwitch;
    programmaticSwitch = false;

    const changed = lastVariantId !== null && lastVariantId !== current.id;
    lastVariantId = current.id;

    if (isDouble) {
      if (!triggeredByQty) {
        // Selección manual de la pestaña de oferta (o carga inicial): cantidad fija en 2.
        setQtyDisplay(2);
      }
      showMsg(MSG_OFFER_ACTIVE);
    } else {
      if (changed && !triggeredByQty) {
        // Volvió a "1 frasco" por clic manual en la pestaña: cantidad fija en 1.
        setQtyDisplay(1);
      }
      // Si el cambio vino de +/- (triggeredByQty), la cantidad ya quedó correcta — no tocar.
      const qtyNow = Number(qtyEl.value);
      if (qtyNow === 2) {
        showMsg(MSG_OFFER_WILL_APPLY);
      } else {
        hideMsg();
      }
    }
  }

  qtyEl.addEventListener('update', handleQtyUpdate);
  variantEl.addEventListener('change', () => setTimeout(syncOnVariantChange));
  setTimeout(syncOnVariantChange);
}

/* ---------------------------------------------------------------------- */
/* Parte 2: carrito (auto-consolidación + aviso en la línea)              */
/* ---------------------------------------------------------------------- */

function initCartOfferSync() {
  import('cart-store')
    .then(({ default: Cart }) => {
      let reconciling = false;
      let toastTimer = null;

      function showCartToast() {
        let toast = document.querySelector('[data-oferta-2x1-toast]');
        if (!toast) {
          toast = document.createElement('div');
          toast.setAttribute('data-oferta-2x1-toast', '');
          toast.style.cssText =
            'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;' +
            'background:#1e7c34;color:#fff;padding:10px 18px;border-radius:8px;font-size:13px;' +
            'font-weight:600;box-shadow:0 4px 14px rgba(0,0,0,.18);max-width:90vw;text-align:center;';
          document.body.appendChild(toast);
        }
        toast.textContent = MSG_CART_OFFER_APPLIED;
        toast.style.display = 'block';
        if (toastTimer) clearTimeout(toastTimer);
        toastTimer = setTimeout(() => {
          toast.style.display = 'none';
        }, 4000);
      }

      async function reconcile(state) {
        if (reconciling) return;
        const items = (state && state.cart && state.cart.items) || [];
        if (items.length === 0) return;

        const byProduct = {};
        items.forEach((it) => {
          (byProduct[it.product_id] = byProduct[it.product_id] || []).push(it);
        });

        const planned = {};
        for (const productId in byProduct) {
          const group = byProduct[productId];
          const singleItems = group.filter((it) => SINGLE_RE.test(it.variant_title || ''));
          if (singleItems.length === 0) continue;

          const singleQty = singleItems.reduce((sum, it) => sum + it.quantity, 0);
          if (singleQty < 2) continue;

          const bundles = Math.floor(singleQty / 2);
          const remainder = singleQty % 2;

          const doubleItem = group.find((it) => DOUBLE_RE.test(it.variant_title || ''));
          let doubleVariantId = doubleItem ? doubleItem.variant_id : null;
          const doubleExistingQty = doubleItem ? doubleItem.quantity : 0;

          if (!doubleVariantId) {
            const handle = singleItems[0].handle;
            if (!handle) continue;
            try {
              const res = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}products/${handle}.js`);
              if (!res.ok) continue;
              const product = await res.json();
              const match = (product.variants || []).find((v) => DOUBLE_RE.test(v.title || ''));
              if (match) doubleVariantId = match.id;
            } catch (e) {
              continue;
            }
          }
          if (!doubleVariantId) continue;

          const singleVariantId = singleItems[0].variant_id;
          planned[singleVariantId] = remainder;
          planned[doubleVariantId] = doubleExistingQty + bundles;
        }

        if (Object.keys(planned).length === 0) return;

        reconciling = true;
        try {
          await Cart.update({ updates: planned });
          showCartToast();
        } catch (e) {
          // Si falla, no se aplica el cambio automático; no se cobra de más en ningún caso.
        } finally {
          reconciling = false;
        }
      }

      function decorateCartItems() {
        const state = Cart.getState();
        const items = (state && state.cart && state.cart.items) || [];
        document.querySelectorAll('cart-item').forEach((el) => {
          const key = el.getAttribute('key');
          if (!key) return;
          const item = items.find((i) => i.key === key);
          const existingBadge = el.querySelector('[data-oferta-2x1-badge]');
          if (!item || !DOUBLE_RE.test(item.variant_title || '')) {
            if (existingBadge) existingBadge.remove();
            return;
          }
          if (existingBadge) return;
          const container = el.querySelector('cart-item-details') || el;
          const badge = document.createElement('div');
          badge.setAttribute('data-oferta-2x1-badge', '');
          badge.textContent = MSG_CART_OFFER_APPLIED.replace('Aplicamos tu oferta: ', '');
          badge.style.cssText = 'margin-top:4px;font-size:12px;font-weight:600;color:#1e7c34;';
          container.appendChild(badge);
        });
      }

      reconcile(Cart.getState());
      Cart.subscribe((state) => {
        reconcile(state);
        setTimeout(decorateCartItems, 50);
      });
      setTimeout(decorateCartItems, 50);
      document.addEventListener('DOMContentLoaded', () => setTimeout(decorateCartItems, 50));
    })
    .catch(() => {
      /* Si el módulo del carrito no está disponible, no se hace nada. */
    });
}

/* ---------------------------------------------------------------------- */

injectSelectedPresentationStyles();
initProductOfferSync();
initCartOfferSync();
